import { useAuth } from '../contexts/AuthContext';
import { apiClient } from '../api/client';

export function LanguageToggle() {
  const { user, setUser } = useAuth();
  const lang = user?.preferredLanguage || 'en';

  const toggle = async () => {
    const newLang = lang === 'en' ? 'krio' : 'en';
    try {
      await apiClient('/auth/preferences', { method: 'PATCH', body: { preferredLanguage: newLang } });
      setUser((prev) => prev ? { ...prev, preferredLanguage: newLang } : prev);
    } catch {
      // ignore
    }
  };

  return (
    <button
      onClick={toggle}
      style={{
        background: 'none',
        border: '1px solid #d1d5db',
        borderRadius: '16px',
        padding: '4px 12px',
        fontSize: '0.78rem',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
      }}
      aria-label={`Switch to ${lang === 'en' ? 'Krio' : 'English'}`}
    >
      <span>{lang === 'en' ? '\u{1F1EC}\u{1F1E7}' : '\u{1F1F8}\u{1F1F1}'}</span>
      <span style={{ fontWeight: 600 }}>{lang === 'en' ? 'English' : 'Krio'}</span>
    </button>
  );
}
